// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"bf6f3313","605":"224e385c","809":"62452d41","981":"7a327805"}[chunkId] + ".chunk.js";
};